<template>
  <transition name="slide">
    <div v-if="messages.length > 0" @click="handleNotificationClicked()" :class="`flash arrow-top-right alert t-sm bg-white`">
      <div class="flash--left text-left">
        <notification-image :notification="notification" />
      </div>
      <div class="flash--right text-left">
        <span v-html="messages[0]"></span>
        <copy-icon v-if="notification.copy_text" :text="notification.copy_text" />
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Whenever the user receives a notification, this Flash component will briefly show it.
 * It looks like a "toast" message, and is attached to the Notifications menu.
 */

import NotificationImage from '@/components/shared/NotificationImage'
import CopyIcon from '@/components/shared/CopyIcon'

export default {
  name: 'flash',
  components: {
    NotificationImage,
    CopyIcon
  },
  data () {
    return {
      notification: {},
      messages: [],
      variant: 'default',
      delay: 5000
    }
  },
  created () {
    this.$events.$on('notify', (messages, variant, notification) => {
      typeof (messages) === 'object' ? this.messages = messages : this.messages = [messages]

      this.notification = notification
      this.variant = variant

      setTimeout(this.hide, this.delay)
    })
  },
  methods: {
    hide () {
      this.messages = []
      this.notification = {}
    },
    handleNotificationClicked () {
      const link = this.notification.link
      if (link) {
        if (link.startsWith('https:')) {
          window.open(link, '_blank')
        } else if (link.startsWith('mailto:')) {
          window.location.href = link
        } else {
          this.$router.push({ path: `${link}` })
        }
      }
      this.hide()

      if (!this.notification.silent) {
        this.$events.$emit('un-notify-bell', this.notification.notification_id)
      }
    }
  },
  destroyed () {
    this.$events.$off('notify')
  }
}
</script>
